import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatShiftDateTime } from './scheduleHelpers';

function SimpleShiftTable({
  shifts = [],
  showHeader = false,
  onRowClick,
  rowClassName = 'whose-scheduled-date-row',
}) {
  const { t } = useTranslation();
  return (
    <Table
      showHeader={showHeader}
      rowKey="id"
      columns={[
        {
          dataIndex: 'title',
          title: 'Title',
        }, {
          dataIndex: 'startTime',
          title: 'Time',
          render: (startTime, { endTime }) => (
            <span className={showHeader ? '' : 'whose-scheduled-date'}>
              {formatShiftDateTime(startTime, endTime)}
            </span>
          ),
        },
        {
          dataIndex: 'projectName',
          title: t('Project'),
        },
        {
          dataIndex: 'phaseName',
          title: 'Phase',
        },
        {
          dataIndex: 'costcodeName',
          title: 'Cost Code',
        },
      ]}
      dataSource={shifts}
      pagination={false}
      rowClassName={() => rowClassName}
      size="small"
      onRow={(record) => ({
        onClick: onRowClick ? () => onRowClick(record) : null,
      })}
    />
  );
}

SimpleShiftTable.propTypes = {
  shifts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showHeader: PropTypes.bool,
  onRowClick: PropTypes.func,
  rowClassName: PropTypes.string,
};

SimpleShiftTable.defaultProps = {
  showHeader: false,
  onRowClick: null,
  rowClassName: 'whose-scheduled-date-row',
};

export default SimpleShiftTable;
